import { useCallback, useState } from 'react';
import { useStores } from '../../stores';
import { toJS } from 'mobx';

export const useCohortModal = () => {
  const [open, setOpen] = useState<boolean>(false);

  const cohortDetailsStore = useStores().cohortDetailsStore;
  const conditionsDetails = toJS(cohortDetailsStore.conditionsDetails);
  const isEditMode = conditionsDetails.length > 0;

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);
  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    open,
    openModal,
    closeModal,
    isEditMode,
  };
};
